import resolveConfig from 'tailwindcss/resolveConfig'
import tailwindConfig from '../../../tailwind.config.js'
import toPx from 'to-px';

export {
    scrollBy,
    scrollTo,
} from './scroll';

const config = resolveConfig(tailwindConfig)

export const breakpoints = (() => (
    Object.keys(config.theme.screens).reduce(
        (breakpoints, breakpoint) => ({
            ...breakpoints,
            [breakpoint]: (
                toPx(
                    config.theme.screens[breakpoint]
                )
            )
        }),
        {}
    )
))();

export const isScreenAtLeast = (size) => (
    $(window).outerWidth() >= breakpoints[size]
);

export const colors = config.theme.colors;

export const loadSvg = (key) => (
    $(`[data-svg="${key}"]`).html()
);

